<template>
  <div class="page_SelfDeparture">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div>
          <el-form :inline="true" :model="listQuery" class="re_down_form declareForm" label-width="100px">
            <el-form-item label="项目名称" v-if="activeName!='3'">
              <el-select v-model="listQuery.projectId" placeholder="" filterable clearable @change="getList" size="small" style="width:180px">
                <el-option label="全部" :value="0"></el-option>
                <el-option v-for="item in proNameList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="姓名" v-if="activeName2 == '2' || activeName2 == '4'">
              <el-input v-model="listQuery.name" size="small" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="身份证" v-if="activeName2 == '2' || activeName2 == '4'">
              <el-input v-model="listQuery.idCard" size="small" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="公司全称" v-if="activeName == '3'">
              <el-select v-model="listQuery.companyName" placeholder="" size="small" clearable filterable style="width:180px">
                <el-option v-for="(item, index) in legList" :key="index" :value="item.CompanyName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="编号" v-if="activeName == '3'">
              <el-input v-model="listQuery.documentNumber" size="small" style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="开始时间:" v-if="activeName2 == '3'">
              <el-date-picker size="small" value-format="yyyy-MM" v-model="listQuery.startMonth" type="month" style="width:180px" placeholder="选择开始时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间:" v-if="activeName2 == '3'">
              <el-date-picker size="small" value-format="yyyy-MM" v-model="listQuery.endMonth" type="month" style="width:180px" placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item v-if="activeName2 == '2' || activeName2 == '3' || activeName2 == '4' || activeName == '3'">
              <el-tooltip class="scr_icon cp" effect="dark" content="高级检索项" placement="top-start">
                <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
              </el-tooltip>
            </el-form-item>

          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1" v-if="activeName2 == '2' || activeName2 == '3' || activeName2 == '4' || activeName == '3'">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="100px">
          <el-form-item label="开始时间:" v-if="activeName2 == '4'">
            <el-date-picker size="small" value-format="yyyy-MM" v-model="listQuery.startMonth" type="month" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" v-if="activeName2 == '4'">
            <el-date-picker size="small" value-format="yyyy-MM" v-model="listQuery.endMonth" type="month" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="开始时间:" v-if="activeName == '3'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.start" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间:" v-if="activeName == '3'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.end" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="公司全称" v-if="activeName2 == '2' || activeName2 == '4'">
            <el-select v-model="listQuery.companyName" placeholder="" size="small" clearable filterable style="width:180px">
              <el-option v-for="(item, index) in legList" :key="index" :value="item.CompanyName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="确认开始时间:" v-if="activeName2 == '3' || activeName2 == '4'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.confirmStart" type="date" style="width:180px" placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="确认结束时间:" v-if="activeName2 == '3' || activeName2 == '4'">
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="listQuery.confirmEnd" type="date" style="width:180px" placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="编号" v-if="activeName2 == '2'|| activeName2 == '4'">
            <el-input v-model="listQuery.documentNumber" size="small" style="width:180px"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="drop-footer">
        <!-- <el-button size="small" plain @click="resetHandle()">清空</el-button> -->
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>自离公告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="自离名单确认" name="0"></el-tab-pane>
          <el-tab-pane label="自离信息维护" name="1"></el-tab-pane>
          <el-tab-pane label="自离名单确认汇总" name="2"></el-tab-pane>
          <el-tab-pane label="自离公告公示版" name="3"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2" v-if="activeName!='3'">
          <el-tab-pane label="项目(自离名单人数)" name="0" v-if="activeName == '0'"></el-tab-pane>
          <el-tab-pane label="项目" name="1" v-if="activeName == '1'"></el-tab-pane>
          <el-tab-pane label="自离人员" name="2" v-if="activeName == '1'"></el-tab-pane>
          <el-tab-pane label="项目" name="3" v-if="activeName == '2'"></el-tab-pane>
          <el-tab-pane label="自离人员明细" name="4" v-if="activeName == '2'"></el-tab-pane>
        </el-tabs>
        <div style="padding: 10px;" class="flex">
          <el-button type="warning" size="small" v-preventReClick @click="batchConfirm()" v-if="activeName2 == '0'">确
            认</el-button>
          <el-button type="success" size="small" v-preventReClick @click="impDtlHandle({ noticeId: 0 }, 1)" v-if="activeName == '1'">导入自离人员明细</el-button>
          <el-button type="primary" size="small" v-preventReClick :loading="exportLoading" @click="expList()" v-if="activeName2!='5'">导
            出</el-button>
          <el-button type="primary" size="small" v-preventReClick @click="archive()" v-if="activeName2=='5'">归档</el-button>
        </div>

        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange" :max-height="tableHeight < 360 ? 360 : tableHeight">
          <el-table-column key="mul" type="selection" width="55" align="center"></el-table-column>
          <!-- <el-table-column label="序号" :show-overflow-tooltip="true" align="center" min-width="100">
            <template slot-scope="{$index}">{{ (listQuery.pagination.page - 1 ) * listQuery.pagination.pageSize + $index + 1 }}</template>
</el-table-column> -->
          <template v-if="activeName2 == '0' || activeName2 == '1' || activeName2 == '3'">
            <el-table-column prop="month" label="所属月" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="strprojectName" label="项目名称" :show-overflow-tooltip="true" align="center" min-width="170">
            </el-table-column>
            <el-table-column prop="peopleNum" v-if="activeName2 == '0'" label="当月自离人数" :show-overflow-tooltip="true" align="center" min-width="100">
              <template slot-scope={row}>
                <div class="greenName cp" @click="viewDtl(row)">{{ row.peopleNum }}</div>
              </template>
            </el-table-column>

            <el-table-column prop="peopleNum" v-if="activeName2 == '1' || activeName2 == '3'" label="所属月自离人数" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="confirmTime" v-if="activeName2 == '3'" label="确认时间" :show-overflow-tooltip="true" align="center" min-width="100">
              <template slot-scope={row}>{{ row.confirmTime ? row.confirmTime.split('T')[0] : '' }}</template>
            </el-table-column>
            <el-table-column prop="customerService" label="客服" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="serviceDepartment" label="服务部门" :show-overflow-tooltip="true" align="center" min-width="100">
            </el-table-column>
            <el-table-column prop="Bankcard" label="操作" align="center" :width="activeName2 == '1' ? 180 : 100">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="confirmHandle([row.noticeId])" v-if="activeName2 == '0'">确认</el-button>
                  <!-- <el-button type="text" size="small" @click="impDtlHandle(row,0)" v-if="activeName2=='1'">导入自离人员明细</el-button> -->
                  <el-popconfirm title="请确认是否删除" @confirm="delHandle([row.noticeId], 1)" style="margin: 0 10px;" v-if="activeName2 == '1'">
                    <el-button type="text" slot="reference" size="small">自离人员明细整批删除</el-button>
                  </el-popconfirm>
                  <el-button type="text" size="small" @click="viewDtl(row)" v-if="activeName2 == '3'">明细</el-button>
                  <el-popconfirm title="请确认是否退回" @confirm="returnHandle(row)" style="margin: 0 10px;" v-if="activeName2 == '3'">
                    <el-button type="text" slot="reference" size="small">退回</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>
          <template v-if="activeName2 == '2' || activeName2 == '4'">
            <el-table-column prop="strprojectName" key="1" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="companyName" key="2" label="公司全称" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="name" key="3" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="idCard" key="4" label="身份证号码" min-width="160" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="documentNumber" key="4.2" label="自离公告公示编号" min-width="130" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="resignationDate" key="5" label="离职日期" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.resignationDate ? row.resignationDate.split('T')[0] : '' }}</template>
            </el-table-column>
            <el-table-column prop="inFactResignationDate" key="6" label="旷工时间" min-width="240" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>从{{ !isNull(row.inFactResignationDate) ?
                row.inFactResignationDate.split('T')[0] : row.resignationDate ? row.resignationDate.split('T')[0] : ''
              }}起至今
              </template>
            </el-table-column>
            <el-table-column prop="Bankcard" label="操作" align="center" width="100" fixed="right">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="editHandle(row)" v-if="activeName2 == '2'">编辑</el-button>
                  <el-popconfirm :title="'请确认是否删除？'" v-if="activeName2 == '2'" @confirm="delHandle([row.personnelId], 2)" style="margin:0 10px">
                    <el-button type="text" slot="reference" size="small" v-preventReClick>删除</el-button>
                  </el-popconfirm>
                </div>
              </template>
            </el-table-column>
          </template>

          <template v-if="activeName2 == '5'">
            <el-table-column prop="companyName" key="1" label="公司全称" min-width="140" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="documentNumber" key="2" label="编号" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="generationDate" key="3" label="生成时间" min-width="140" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>{{ row.generationDate ? row.generationDate.replace('T',' ') : '' }}</template>
            </el-table-column>
            <el-table-column label="操作" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}>
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="downHandle(row)">下载公告文件</el-button>
                </div>
              </template>
            </el-table-column>
          </template>

        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pagination.page" :page-size="Number(listQuery.pagecount)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="showDtl" width="1050px">
      <el-table :data="dtlData" border class="doc_table" style="width:100%" max-height="500px">
        <!-- <el-table-column prop="strprojectName" label="项目名称" min-width="140" :show-overflow-tooltip="true" align="center">
        </el-table-column> -->
        <el-table-column prop="companyName" label="公司全称" min-width="180" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="name" label="姓名" min-width="100" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="idCard" label="身份证号码" min-width="160" :show-overflow-tooltip="true" align="center">
        </el-table-column>
        <el-table-column prop="resignationDate" label="离职日期" min-width="120" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>{{ row.resignationDate ? row.resignationDate.split('T')[0] : '' }}</template>
        </el-table-column>
        <el-table-column prop="inFactResignationDate" label="旷工时间" min-width="240" :show-overflow-tooltip="true" align="center">
          <template slot-scope={row}>从{{ !isNull(row.inFactResignationDate) ? row.inFactResignationDate.split('T')[0] :
            row.resignationDate.split('T')[0] }}起至今</template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog title="导入自离人员明细" :visible.sync="showImport" width="500px">
      <el-form :model="impForm" ref="impForm" :rules="rules" label-width="140px">
        <el-form-item label="项目名称" prop="projectId" v-if="type == 1">
          <el-select v-model="impForm.projectId" placeholder="" filterable clearable @change="getList" size="small" style="width:300px">
            <el-option v-for="item in proNameList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入模板">
          <div class="blueName cp" @click="downTemp">下载模板</div>
        </el-form-item>
        <el-form-item label="导入自离人员明细" prop="excelPath">
          <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="1" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="fileList">
            <el-button size="small" type="primary">导入</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImport = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="错误提示" :visible.sync="showError" width="600px">
      <el-table :data="errorList" border style="width: 100%" max-height="500px">
        <el-table-column label="错误信息" min-width="550" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{$index}">{{ errorList[$index] }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="showError = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="异常提示" :visible.sync="showtip" width="600px">
      <el-table :data="tipList" border style="width: 100%" max-height="500px">
        <el-table-column label="错误信息" min-width="550" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{$index}">第{{ Number(errorList[$index]) - 1 }}行花名册不是自离</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="showtip = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="showEdit" width="500px">
      <el-form :model="editForm" ref="editForm" :inline="true" label-width="100px">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="editForm.name" readonly style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="editForm.idCard" readonly style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="公司全称" prop="companyName">
          <el-select v-model="editForm.companyName" size="small" style="width: 300px;" placeholder="" filterable>
            <el-option v-for="(item, index) in legList" :key="index" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="离职日期" prop="resignationDate">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="editForm.resignationDate" type="date" style="width:300px" placeholder="">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="实际离职日期" prop="inFactResignationDate">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="editForm.inFactResignationDate" type="date" style="width:300px" placeholder="">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmEdit" size="small">提
          交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="归档" :visible.sync="showArchive" width="500px">
      <el-form :model="archiveForm" ref="archiveForm" :rules="rules" label-width="100px">
        <el-form-item label="开始时间" prop="start">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="archiveForm.start" type="date" style="width:300px" placeholder="">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="end">
          <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="archiveForm.end" type="date" style="width:300px" placeholder="">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="公司全称">
          <el-select v-model="archiveForm.companyName" size="small" style="width: 300px;" placeholder="" filterable>
            <el-option v-for="(item, index) in legList" :key="index" :value="item.CompanyName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-select v-model="archiveForm.projectId" placeholder="" filterable size="small" style="width:300px">
            <el-option label="全部" :value="0"></el-option>
            <el-option v-for="item in proNameList" :key="item.Id" :label="item.StrprojectName" :value="item.Projectid"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showArchive = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmArchive" size="small">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment'
  import checkPermission from '@/utils/permission' // 权限判断函数
  import tabs from "./components/declareTabs.vue";
  import {
    number
  } from "mathjs";
  export default {
    components: {
      tabs
    },
    data() {
      return {
        listQuery: {
          status: 0, //状态0：归档1：确认（写死必传）
          noticeId: [], //公告id集合（勾选导出时使用）
          userid: Cookies.get("userid-b"),
          startMonth: '',
          endMonth: '',
          projectId: 0,
          pagination: {
            page: 1,
            pageSize: 10,
            orders: []
          }
        },
        tableHeight: 0,
        multipleSelection: [],
        totalCount: 0,
        activeName: '0',
        activeName2: '0',
        roletype: localStorage.loginRoletype,
        showDropScreen: -1,
        loading: false,
        exportLoading: false,
        tableTitle: [], //表头
        tableData: [],
        proNameList: [],
        dtlData: [],
        showDtl: false,
        showDropScreen: -1,
        fileList: [],
        isBtnLoading: false,
        showImport: false,
        impForm: {
          userid: Cookies.get("userid-b"),
          noticeId: 0,
          excelPath: '',
          isdelete: true
        },
        rules: {
          excelPath: {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          },
          projectId: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          companyName: {
            required: true,
            message: '请选择公司全称',
            trigger: 'change'
          },
          inFactResignationDate: {
            required: true,
            message: '请选择实际离职日期',
            trigger: 'change'
          },
          name: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          idCard: {
            required: true,
            message: '请输入身份证',
            trigger: 'blur'
          },
          resignationDate: {
            required: true,
            message: '请选择离职日期',
            trigger: 'change'
          },
          start: {
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          },
          end: {
            required: true,
            message: '请选择结束时间',
            trigger: 'change'
          },
        },
        errorList: [],
        showError: false,
        showEdit: false,
        info: {},
        editForm: {
          userid: '',
          personnelId: 0,
          companyName: '',
          name: '',
          idCard: '',
          resignationDate: '',
          inFactResignationDate: ''
        },
        tipList: [],
        showtip: false,
        legList: [],
        type: 0,
        showArchive: false,
        archiveForm: {
          start: '',
          end: '',
          projectId: 0,
          companyName: ''
        },
      }
    },
    created() {
      this.getProList();
      this.tableHeight = Number(document.body.clientHeight) - 180;
      this.listQuery.startMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM');
      this.listQuery.endMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM');
      this.getList();
      this.getLegalSubjectList();
    },
    methods: {
      checkPermission,
      //取签约主体列表
      getLegalSubjectList() {
        let data = {
          pageNum: '1',
          pageSize: '10000'
        }
        xz.getlegalsubjectlist(data).then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.data;
          } else {
            this.legList = [];
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      searchHandle() {
        this.listQuery.pagination.page = 1;
        this.getList();
      },
      changeTab() {
        if (this.activeName != '3') {
          this.listQuery = {
            status: 0, //状态0：归档1：确认（写死必传）
            noticeId: [], //公告id集合（勾选导出时使用）
            userid: Cookies.get("userid-b"),
            startMonth: this.listQuery.startMonth,
            endMonth: this.listQuery.endMonth,
            projectId: this.listQuery.projectId,
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
          if (this.activeName == '0') {
            this.listQuery.status = 0;
            this.activeName2 = '0'
          } else if (this.activeName == '1') {
            this.listQuery.status = 0;
            this.activeName2 = '1'
          } else if (this.activeName == '2') {
            this.listQuery.status = 1;
            this.listQuery.status = 1;
            this.activeName2 = '3'
          }
        } else {
          this.activeName2 = '5'
          this.listQuery = {
            start: '',
            end: '',
            documentNumber: '',
            companyName: '',
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
        }
        this.getList()
      },
      changeTab2() {
        if (this.activeName2 == '0' || this.activeName2 == '1' || this.activeName2 == '3') {
          this.listQuery = {
            status: 0, //状态0：归档1：确认（写死必传）
            noticeId: [], //公告id集合（勾选导出时使用）
            userid: Cookies.get("userid-b"),
            startMonth: this.listQuery.startMonth,
            endMonth: this.listQuery.endMonth,
            projectId: this.listQuery.projectId,
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
          if (this.activeName2 == '3') {
            // this.listQuery.startMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM');
            // this.listQuery.endMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM');
            this.listQuery.confirmStart = '';
            this.listQuery.confirmEnd = '';
            this.listQuery.status = 1;
          }
        } else if (this.activeName2 == '2' || this.activeName2 == '4') {
          this.listQuery = {
            status: 0,
            personnelId: [], //人员id集合（勾选导出时使用）
            userid: Cookies.get("userid-b"),
            startMonth: this.listQuery.startMonth,
            endMonth: this.listQuery.endMonth,
            projectId: this.listQuery.projectId,
            companyName: '',
            name: '',
            idCard: '',
            pagination: {
              page: 1,
              pageSize: 10,
              orders: []
            }
          }
          this.$set(this.listQuery, 'documentNumber', '')
          if (this.activeName2 == '4') {
            // this.listQuery.startMonth = moment().subtract(1, 'months').startOf('month').format('YYYY-MM');
            // this.listQuery.endMonth = moment().subtract(1, 'months').endOf('month').format('YYYY-MM');

            this.listQuery.confirmStart = '';
            this.listQuery.confirmEnd = '';
            this.listQuery.status = 1;
          }
        }
        this.getList();
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      //获取列表
      getList() {
        if (!this.listQuery.projectId || this.listQuery.projectId == null) {
          this.listQuery.projectId = 0;
        }
        if (this.listQuery.startMonth == null) {
          this.listQuery.startMonth = ''
        }
        if (this.listQuery.endMonth == null) {
          this.listQuery.endMonth = ''
        }
        if (this.listQuery.confirmEnd == null) {
          this.listQuery.confirmEnd = ''
        }
        if (this.listQuery.confirmStart == null) {
          this.listQuery.confirmStart = ''
        }
        let pagename = '';
        if (this.activeName == '3') {
          pagename = 'InterviewOnboarding/GetResignationNoticeGroupList';
        } else if (this.activeName2 == '0' || this.activeName2 == '1' || this.activeName2 == '3') {
          pagename = 'InterviewOnboarding/GetResignationNoticeList';
        } else {
          pagename = 'InterviewOnboarding/GetResignationNoticeDetailedList'
        }
        this.loading = true;
        xz.rcFun(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalCount;
            this.loading = false;
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.tableData = [];
          }
        })
      },
      currentChange(val) {
        this.listQuery.pagination.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pagination.page = 1;
        this.listQuery.pagination.pageSize = val;
        this.getList();
      },
      //导出列表
      expList() {
        this.exportLoading = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.forEach(element => {
            if (this.activeName2 == '0' || this.activeName2 == '1' || this.activeName2 == '3') {
              d.noticeId.push(element.noticeId)
            } else {
              d.personnelId.push(element.personnelId)

            }
          });
        }
        delete d.pagination;
        d.filename = '自离公告导出.xlsx';
        let pagename = '';
        if (this.activeName2 == '0' || this.activeName2 == '1' || this.activeName2 == '3') {
          pagename = 'InterviewOnboarding/ReportResignationNoticeData/download'
        } else {
          pagename = 'InterviewOnboarding/ReportResignationNoticeDetailedData/download'
        }
        xz.rcExpFun(d, pagename).then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = '自离公告导出.xlsx';
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.exportLoading = false;
          } catch (e) {
            this.exportLoading = false;
            this.$message.error('导出异常')
          }
        })
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      viewDtl(row) {
        this.dtlData = [];
        let str = `InterviewOnboarding/GetResignationNoticeDetailedCheck?NoticeId=${row.noticeId}`
        xz.rcGetFun(str).then(res => {
          if (res.status == 'ok') {
            this.dtlData = res.data;
            this.showDtl = true;
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      batchConfirm() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          this.multipleSelection.forEach(e => {
            arr.push(e.noticeId)
          });
          this.confirmHandle(arr);
        } else {
          this.$message.warning('请选择要确认的数据！')
        }
      },
      confirmHandle(ids) {
        let d = {
          noticeIds: ids,
          userid: Cookies.get("userid-b")
        }
        this.loading = true;
        xz.rcFun(d, 'InterviewOnboarding/SetResignationNoticeConfirm').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('确认成功！');
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      delHandle(id, type) {
        let d = {
          type,
          ids: id
        }
        this.loading = true;
        xz.rcFun(d, 'InterviewOnboarding/SetResignationNoticeDetailedDelete').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('删除成功！');
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      impDtlHandle(row, type) {
        this.type = type;
        if (type == 0) {
          this.impForm = {
            userid: Cookies.get("userid-b"),
            noticeId: row.noticeId,
            excelPath: '',
            isdelete: this.activeName2 == '3' ? true : false
          };
        } else {
          this.impForm = {
            userid: Cookies.get("userid-b"),
            projectId: null,
            excelPath: '',
            isdelete: this.activeName2 == '3' ? true : false
          };
        }
        this.fileList = [];
        this.showImport = true;
      },
      handleExceed() {
        this.$message.warning(`只能导入 1 个文件`);
      },
      // 删除
      handleFileRemove() {
        this.impForm.excelPath = '';
      },
      // 上传
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.impForm.excelPath = res;
          } else {
            this.impForm.excelPath = ''
          }
        });
      },
      confirmImport() {
        if (this.impForm.excelPath) {
          this.isBtnLoading = true;
          // let pagename = this.type == 0 ? 'InterviewOnboarding/SetResignationNoticeDetailedImport' : 'InterviewOnboarding/ImportResignationNoticeDetailed'
          xz.rcFun(this.impForm, 'InterviewOnboarding/ImportResignationNoticeDetailed').then(res => {
            if (res.status == 'ok') {
              this.$message.success('导入成功！');
              this.getList();
              this.isBtnLoading = false;
              this.showImport = false;
              if (res.data != undefined && res.data.length > 0) {
                this.tipList = res.data;
                this.showtip = true;
              }
            } else {
              this.$message.error(res.msg);
              this.getList();
              this.isBtnLoading = false;
              this.showImport = false;
              if (res.data != undefined && res.data.length > 0) {
                this.errorList = res.data;
                this.showError = true;
              }
            }
          })
        } else {
          this.$message.warning('请选择文件！')
        }
      },
      downTemp() {
        let path = this.$store.state.EMP.tablePath + 'excel/9c895257-5e33-4888-9bd8-adb6df000386/E20251125092029183.xlsx';
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = "导入自离人员明细.xlsx";
        aTag.click();
      },
      editHandle(row) {
        this.isBtnLoading = false;
        this.info = row;
        this.editForm = {
          userid: Cookies.get("userid-b"),
          personnelId: row.personnelId,
          companyName: row.companyName,
          name: row.name,
          idCard: row.idCard,
          resignationDate: row.resignationDate,
          inFactResignationDate: row.inFactResignationDate
        }
        this.showEdit = true;
      },
      confirmEdit() {
        this.$refs["editForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.rcFun(this.editForm, 'InterviewOnboarding/SetResignationNoticeDetailedSave').then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.showEdit = false;
                this.isBtnLoading = false;
                this.getList();
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN" ||
          o.indexOf("1900") > -1
        );
      },
      //下载自离公告文件
      downHandle(row) {
        if (!this.loading) {
          this.loading = true;
          let d = {
            founder: Cookies.get("userid-b"),
            filename: `自离公告 - ${row.companyName} - ${row.documentNumber}.docx`,
            documentNumber: row.documentNumber
          }
          xz.rcFun(d, 'InterviewOnboarding/GetNoticeGroupFileDownLoad').then(res => {
            if (res.status == 'ok') {
              this.loading = false;
              this.$store.dispatch('triggerRefresh')
            } else {
              this.loading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      //归档
      archive() {
        this.archiveForm = {
          start: '',
          end: '',
          projectId: 0,
          companyName: ''
        }
        this.showArchive = true;
      },
      confirmArchive() {
        this.$refs["archiveForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.rcFun(this.archiveForm, 'InterviewOnboarding/SetResignationNoticeGroupArchiving').then(res => {
              if (res.status == 'ok') {
                this.$message.success('归档成功');
                this.showArchive = false;
                this.isBtnLoading = false;
                this.getList();
              }
            })
          } else {
            this.isBtnLoading = false;
            this.$message.warning(res.msg)
          }
        })
      },
      returnHandle(row) {
        let d = {
          noticeId: row.noticeId
        }
        this.loading = true;
        xz.rcFun(d, 'InterviewOnboarding/SetResignationNoticeBlack').then(res => {
          if (res.status == 'ok') {
            this.loading = false;
            this.$message.success('退回成功！');
            this.getList();
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.getList();
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .r_dropDownScreen {
    padding-left: 29px;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .greenName {
    font-weight: 600;
    font-size: 14px;
  }
</style>
<style>
  .page_SelfDeparture .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_SelfDeparture .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_SelfDeparture .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_SelfDeparture .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_SelfDeparture .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_SelfDeparture .declareForm .el-form-item {
    margin-bottom: 10px;
  }

  .page_SelfDeparture .declareForm .el-form-item__error {
    top: 34px;
  }
</style>